import { Container } from "./Typography.styles";
import { TypographyProps } from "./Typography.types";

const Typography: React.FC<TypographyProps> = ({ children, ...innerProps }) => (
  <Container {...innerProps}>{children}</Container>
);

export default Typography;
